import { IconProps } from "@/models";

export function InfoIconOutlineYellow({
  size = 20,
  color = "#000",
  opacity = "1",
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >

      <path d="M12 1.49998C6.20156 1.49998 1.5 6.20155 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20155 17.7984 1.49998 12 1.49998ZM12 20.7187C7.18594 20.7187 3.28125 16.814 3.28125 12C3.28125 7.18592 7.18594 3.28123 12 3.28123C16.8141 3.28123 20.7188 7.18592 20.7188 12C20.7188 16.814 16.8141 20.7187 12 20.7187Z" fill="#C68A31" />
      <path d="M10.875 16.125C10.875 16.4234 10.9935 16.7095 11.2045 16.9205C11.4155 17.1315 11.7016 17.25 12 17.25C12.2984 17.25 12.5845 17.1315 12.7955 16.9205C13.0065 16.7095 13.125 16.4234 13.125 16.125C13.125 15.8266 13.0065 15.5405 12.7955 15.3295C12.5845 15.1185 12.2984 15 12 15C11.7016 15 11.4155 15.1185 11.2045 15.3295C10.9935 15.5405 10.875 15.8266 10.875 16.125ZM11.4375 13.5H12.5625C12.6656 13.5 12.75 13.4156 12.75 13.3125V6.93748C12.75 6.83436 12.6656 6.74998 12.5625 6.74998H11.4375C11.3344 6.74998 11.25 6.83436 11.25 6.93748V13.3125C11.25 13.4156 11.3344 13.5 11.4375 13.5Z" fill="#C68A31" />


    </svg>
  );
}
